import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CookiesService } from '../../services/admin services/cookies.service';
import { CommonModule, KeyValuePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  standalone: true,
  imports: [
    KeyValuePipe,
    CommonModule,
  ]
})

export class PrivacyPolicyComponent implements OnInit {

  @Output() close = new EventEmitter<void>();
  @Output() navigateToContact = new EventEmitter<void>();

  companyName = 'The UAV Leasing Company (dba Jet Corp)';
  contactEmail = 'sales@uav-leasing.com';
  dpoEmail = 'sales@uav-leasing.com';
  companyAddress = ' Suite A, Ashtown Business Centre, Navan road, D15 K6WR, Dublin 15, Ireland';
  phoneNumber = '+41 76 733 74 84';

  cookies: { [key: string]: string } = {};

  constructor(
    private _cookiesService: CookiesService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(
  ) {
    this.updateCookiesList();
  }

  updateCookiesList() {
    this.cookies = this._cookiesService.getAllCookies();
    console.log('Current cookies:', JSON.stringify(this.cookies, null, 2)); // Better logging
  }

  async clearAllCookies(): Promise<void> {
    try {
      console.log('Starting cookie deletion process');
      const beforeCookies = this._cookiesService.getAllCookies();
      console.log('Cookies before deletion:', beforeCookies);

      this._cookiesService.clearAllCookies();

      const afterCookies = this._cookiesService.getAllCookies();
      console.log('Cookies after deletion:', afterCookies);

      this._snackBar.open('All cookies cleared successfully', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });

      this.updateCookiesList();
      console.log('Cookie list updated in UI');
    } catch (error) {
      console.error('Error clearing cookies:', error);
      this._snackBar.open('Error clearing cookies', 'Close', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
    }
  }

  deleteSingleCookie(name: string): void {
    this._cookiesService.deleteCookie(name);
    this.updateCookiesList(); // Update the list after deleting
  }

  getCurrentCookies(): { [key: string]: string } {
    const cookies = this._cookiesService.getAllCookies();
    console.log('Current cookies:', cookies); // Add this log
    return cookies;
  }

  navigateBack() {
    // Emit event to parent component
    this.navigateToContact.emit();
    // or just close
    // this.close.emit();
  }
}